import { Injectable } from '@angular/core';
import { IconWeight } from '../directives/icon-weight.enum';

@Injectable()
export abstract class IconParametersService {
  private weightClasses: { [key in IconWeight]: string } = {
    light: 'icon-nimbus-font-light',
    regular: 'icon-nimbus-font-solid',
    bold: 'icon-nimbus-font-solid',
  };

  public getIconParameters(iconName: string, iconWeight: IconWeight): { baseClass: string; iconClass: string } {
    let baseClass = '';
    let iconClass = '';

    if (iconName.startsWith('nimbus-custom')) {
      baseClass = 'icon-nimbus-custom-font';
      iconClass = `icon-${iconName}`;
    } else if (iconName.startsWith('nimbus')) {
      baseClass = this.weightClasses[iconWeight];
      iconClass = `icon-${iconName}`;
    } else {
      return null;
    }

    return { iconClass, baseClass };
  }
}
